
import {Component, Vue} from "vue-property-decorator";
import CarNumberInput from "@/components/CarNumberInput.vue";
import {ICar} from "@/modules/Car/interfaces/car.interface";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {isIOS} from "mobile-device-detect";
import {IBook} from "@/interfaces/book.interface";
import {IAppState} from "@/interfaces/app-state.interface";

@Component({
  components: {
    CarNumberInput,
  },
})
export default class CarNumberBlock extends Vue {
  $refs: any;
  nonStandartIOS = false;
  isIOS;
  enterNumberIOS = false;

  get storeState(): IAppState { return this.$store.state; }
  get createMode() { return this.storeState.car.createMode; }
  get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
  get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

  get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
  get viewMode() { return !this.userAccess.scCarMk; }
  get carsHistory() { return this.storeState.book.books[IBook.BookName.carsHistory]; }

  created() {
    this.isIOS = isIOS;
  }

  inputCarNumber(value) {
    this.$store.commit('car/setFormProperty', { formName: 'formModel', name: 'carNumber', value });
    this.$emit('formItemChange');
  }

  iosNumberClick() {
    if (this.isIOS) {
      this.enterNumberIOS = true;
      this.nonStandartIOS = !this.nonStandartIOS;
      this.enterSpecialNumber();
    }
  }

  enterSpecialNumber(isIOS: boolean = false) {
    if (!this.isIOS || isIOS) {
      Vue.set(this.formModel, 'nonStandartFlag', !this.formModel.nonStandartFlag);
    }

    if (this.formModel.nonStandartFlag || this.nonStandartIOS) {
      setTimeout(() => {
       this.$emit('clearValidate');
        this.$refs.nonStandartNumber.focus();
      }, 0);
    }
  }

  dropdownMenuHandle(command) {
    this.$store.commit('car/setFormProperty', { formName: 'formModel', name: 'carNumber', value: command.carNumber });

    if (command.persName) {
      this.$store.commit('car/setFormProperty', { formName: 'formModel', name: 'persName', value: command.persName });
    }
    if (command.guestFlag) {
      this.$store.commit('car/setFormProperty', { formName: 'formModel', name: 'guestFlag', value: command.guestFlag });
    }

    setTimeout(() => {
      this.$refs.carNumber.prepareData();
      this.$refs.carNumber.$forceUpdate();

      setTimeout(() => this.$emit('formItemChange'), 0);
    }, 0);
  }

  async updateItems() {
    await this.$store.dispatch('book/getBook', { bookNames: [IBook.TableName.carsHistory], needUpdate: true })
  }
}
